import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTypographyCase32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconTypographyCase32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18 5h-4a2 2 0 0 0-2 2v2h8V7a2 2 0 0 0-2-2m-8 2v2H7a4 4 0 0 0-4 4v11a4 4 0 0 0 4 4h18a4 4 0 0 0 4-4V13a4 4 0 0 0-4-4h-3V7a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4m10 4h5a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V13a2 2 0 0 1 2-2zm-9 2h-1v3a1 1 0 1 0 2 0v-1h3v7h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-7h3v1a1 1 0 1 0 2 0v-3z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTypographyCase32);
